import Vue from 'vue'
import moment from 'moment'
import i18n from '@/plugins/i18n'

let locale = 'en'

switch (i18n.locale) {
  case 'ru':
  case 'by':
  case 'kz':
    locale = 'ru'
    break
}

moment.locale(locale)

Vue.filter('date', function (value) {
  if (!value) {
    return null
  }
  return moment(value).format('DD MMMM YYYY')
})

Vue.filter('datetime', function (value) {
  if (!value) {
    return null
  }
  return moment(value).format('DD MMMM YYYY H:mm')
})
